import { VehicleColorOptions } from './vehicle_color_options'

export { VehicleColorOptions } from './vehicle_color_options'
export { VehicleColorSwatch } from './vehicle_color_swatch'

export default VehicleColorOptions